export default class GetGPT {
  static getGPT() {
    GetGPT.loadGPT();
  }
  
  static loadGPT() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.defer = "defer";
    script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";

    document.head.appendChild(script);
  }
}
